//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Areas from '~/utils/areas'
import getFooter from '~/gql/getFooter'
import getMenusWithArea from '~/gql/getMenusWithArea'

export default {
  name: 'LayoutFooter',
  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      sections: [],
      metaMenus: [],
      areas: {
        footer: Areas.FOOTER_MODERN,
        copyright_modern: Areas.COPYRIGHT_MODERN,
      },
    }
  },

  async fetch() {
    // footer sections
    const footer = await this.$graphcms.request(getFooter, {
      area: [this.areas.footer],
      lang: [this.$i18n.locale],
    })
    this.sections =
      footer.sectionMenus && footer.sections
        ? [...footer.sectionMenus, ...footer.sections]
        : []
    this.sections.sort((a, b) => a.priority - b.priority)
    // meta menu
    const metaMenu = await this.$graphcms.request(getMenusWithArea, {
      area: [this.areas.copyright_modern],
      lang: [this.$i18n.locale],
    })
    this.metaMenus = metaMenu.sectionMenus
  },
  computed: {
    classList() {
      return {
        [`footer footer-modern`]: true,
        [`footer--${this.variant}`]: this.variant !== 'default',
      }
    },
  },
  watch: {
    '$i18n.locale'() {
      this.$fetch()
    },
  },
  methods: {
    
  },
}
